import { render, staticRenderFns } from "./Devotionals.vue?vue&type=template&id=36096142&"
import script from "./Devotionals.vue?vue&type=script&lang=js&"
export * from "./Devotionals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports